<template>
  <modal v-if="isShow" :show-modal-close="ratesLeftDays > 0" redesign @close="close">
    <div slot="header">
      <h3>{{ title }}</h3>
    </div>

    <div slot="body">
      <div class="body">
        <div v-if="isRatesExpired">{{ $tr('rates.popup.dateText') }}</div>
        <div v-else>{{ $tr('rates.popup.dateTextNotExpired') }}</div>
      </div>
    </div>

    <div slot="footer">
      <div class="buttons-wrapper">
        <button class="vcv-button" @click="extend_now">{{ $tr('rates.popup.extend') }}</button>
        <button v-if="ratesLeftDays > 0" class="vcv-button gray" @click="close">
          {{ $tr('rates.popup.extendLater') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
  name: 'RatesDatePopup',

  components: {
    Modal
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('company_new', ['isRatesExpired', 'isRatesStarted', 'ratesLeftDays']),

    ...mapGetters('company', { company: 'one' }),

    title() {
      if (!this.isRatesExpired) {
        return this.$tr('rates.popup.dateTitle');
      }

      if (!this.isRatesStarted) {
        return this.$tr('rates.notStart');
      }

      return this.$tr('rates.popup.dateExpiredTitle');
    }
  },

  methods: {
    extend_now() {
      this.$store
        .dispatch('company_new/extend_rates', { company_id: this.company.id, type: 'tariff' })
        .then(() => {
          this.$noty.success(this.$tr('rates.successRequest'));
          this.close();
        })
        .catch(e => {
          this.$noty.error(e.response.data.meta.error.message + '.');
        });
    },

    close() {
      this.$emit('close');
    }
  }
};
</script>
